var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dropdown",
        { staticClass: "d2-mr-20", attrs: { size: "small" } },
        [
          _c("span", { staticClass: "btn-text" }, [
            _vm._v(
              _vm._s(
                _vm.info.USER_NAME ? "你好 " + _vm.info.USER_NAME : "未登录"
              ) + " "
            ),
            _c("i", { staticClass: "el-icon-caret-bottom" })
          ]),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            [
              _c(
                "el-dropdown-item",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.openEditPassword.apply(null, arguments)
                    }
                  }
                },
                [_c("i", { staticClass: "el-icon-edit" }), _vm._v(" 修改密码 ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("editPassword", {
        attrs: { isShowEditPassword: _vm.isShowEditPassword },
        on: {
          closeEditPssword: _vm.closeEditPssword,
          handelDialogSubmit: _vm.handelDialogSubmit
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }